import React, { PureComponent, PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ListItem,
  ListItemIcon,
  ListItemText
} from '@catalytic/pushbot-ui/List';
import KeyboardArrowDown from '@catalytic/pushbot-ui/SvgIcon/KeyboardArrowDown';

export default class UserWatchListMoreItem extends PureComponent {
  static displayName = 'UserWatchListMoreItem';

  static propTypes = {
    /**
     * Class to apply to the list items in the filter list
     */
    className: PropTypes.string,
    /**
     * Location of search page for more items when a user clicks on this item
     */
    href: PropTypes.string,
    /**
     * Click event to apply to the list items in the filter list
     */
    onClick: PropTypes.func
  };

  render() {
    const { className, href, onClick } = this.props;

    return (
      <ListItem margin {...{ className, href, onClick }}>
        <ListItemIcon>
          <KeyboardArrowDown />
        </ListItemIcon>
        <ListItemText
          inherit
          noWrap
          primary={
            <FormattedMessage
              id="UserWatchListMoreItem.primary"
              defaultMessage="More"
            />
          }
        />
      </ListItem>
    );
  }
}



// WEBPACK FOOTER //
// ./js/UserWatchList/UserWatchListMoreItem.js